import { useEffect } from 'react'
import { useCurrentRole } from '../currentRole'
import { useIsPanelPreview } from '../dashboard/panelPreviewContext'
import { useOptionalPanelPatientUid } from '../dashboard/panelContext'
import { useAdvancedCaseload, useRefreshAdvancedCaseload } from './AdvancedCaseloadProvider'
import { advancedPost } from './client'

// Mounts only while a lab note is open, which is what clears the caseload alert (ADR-208).
export const useMarkLabResultsViewed = (orderID: string | null | undefined) => {
  const uid = useOptionalPanelPatientUid()
  const [role] = useCurrentRole()
  const isPreview = useIsPanelPreview()
  const caseload = useAdvancedCaseload()
  const refreshCaseload = useRefreshAdvancedCaseload()
  const alreadyViewed =
    caseload.status === 'ready' &&
    !!uid &&
    !!orderID &&
    (caseload.byUid[uid]?.indicators?.labResultViews?.orderIds.includes(orderID) ?? false)

  useEffect(() => {
    if (uid && orderID && role === 'psychiatrist' && !isPreview && !alreadyViewed) {
      advancedPost(`/patients/${encodeURIComponent(uid)}/lab-results/viewed`, { orderId: orderID })
        .then(refreshCaseload)
        .catch(() => undefined)
    }
  }, [uid, orderID, role, isPreview, alreadyViewed, refreshCaseload])
}
